<template>
    <b-overlay :show="!loaded" rounded="lg">
        <b-card>
            <maps key="officerMap" :loaded="loaded" :officers="officers" :assetTypes="assetTypes" :assets="assets"
                :roles="roles" />
        </b-card>
    </b-overlay>
</template>
<script>
import Maps from './Maps'
export default {
    components: {
        Maps
    },
    data() {
        return {
            loaded: false,
        }
    },
    methods: {
    },
    mounted() {
        this.$store.dispatch('users/fetchAll')
        this.$store.dispatch('company/fetch')
    },

    computed: {
        filteredOfficers() {
            return this.officers
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        officers() {
            return this.$store.getters['analytics/officers']
        },
        roles() {
            return this.$store.getters['analytics/roles']
        },
        assetTypes() {
            return this.$store.getters['analytics/assetTypes']
        },
        assets() {
            console.log()
            return this.$store.getters['analytics/assets']
        },
    },
    watch: {
        officers: {
            handler: function (val) {
                if (val) this.loaded = true
            },
            deep: true,
        },
    },
    async created() {
        await this.$store.dispatch('analytics/getDashboardData')
        await this.$store.dispatch('analytics/getAnalytics')
        this.loaded = true
    },
}

</script>